const MODULE_NAME = 'LoadingModule';

export const GET_LOADING_STATE = `${MODULE_NAME}/GET_LOADING_STATE`;
export const GET_TEST_LOADING = `${MODULE_NAME}/GET_LOADING_STATE`;
